import { render, staticRenderFns } from "./BannersList.html?vue&type=template&id=57eb14f2&scoped=true&external"
import script from "./BannersList.js?vue&type=script&lang=js&external"
export * from "./BannersList.js?vue&type=script&lang=js&external"
import style0 from "./BannersList.scss?vue&type=style&index=0&id=57eb14f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb14f2",
  null
  
)

export default component.exports